export default {
  name: "FormDialog",
  props: {
    type: {
      default: "New",
      type: String,
    },
    activeDialog: {
      default: false,
      type: Boolean,
    },
    btnSalvar: {
      default:true,
      type:Boolean
    },
    btnClose: {
      default:true,
      type:Boolean
    },
    title: {
      required: true,
      type: String,
    },
    btnText: {
      default: "Salvar",
      type: String,
    },
    loadingButton: {
      default: false,
      type: Boolean,
    },
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    activeDialog() {
      this.dialog = !this.dialog;
    },
  },
  methods: {
    close() {
      this.$emit("on-close");
      this.dialog = false;
    },

    save() {

      if (this.type === "New") {
        this.$emit("on-save-new");
        return;
      }

      if (this.type === "Edit") {
        this.$emit("on-save-edit");
        return;
      }
    },
  },
};
